
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 86.77 30"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"14.84","fill":"#06262d"}}),_c('path',{attrs:{"fill":"#2d7037","d":"M14.99 26.5l6.07-11.24-4.81-2.52-1.26 2.51-1.24-2.51-4.81 2.52 6.05 11.24z"}}),_c('path',{attrs:{"fill":"#8dc641","d":"M13.75 12.74l-.61-1.25L4.88 8.1l4.06 7.16 4.81-2.52z"}}),_c('path',{attrs:{"fill":"#079247","d":"M16.25 12.74l.61-1.25 8.26-3.39-4.06 7.16-4.81-2.52z"}}),_c('path',{attrs:{"d":"M15 30C6.73 30 0 23.27 0 15S6.73 0 15 0s15 6.73 15 15-6.73 15-15 15zM15 .33C6.91.33.33 6.91.33 15S6.91 29.67 15 29.67 29.67 23.09 29.67 15 23.09.33 15 .33z","fill":"#8dc641"}}),_c('path',{attrs:{"d":"M67.7 19.23c0 1.98-1.6 3.57-3.56 3.57s-3.56-1.59-3.56-3.57V12.1H58.8v7.13c0 2.96 2.39 5.35 5.35 5.35s5.35-2.39 5.35-5.35V12.1h-1.78v7.13zm-21.69 1.89l-4.94-9.02h-2.03l6.83 12.48h.27l6.83-12.48h-2.03l-4.92 9.02zm33.63.57h-1.78v2.89h8.91V22.8h-7.13v-1.1zm-1.78-9.59v5.54h1.78v-3.76h7.13V12.1h-8.91z","fill":"#06262d"}}),_c('path',{attrs:{"fill":"#8dc641","d":"M77.85 18.77h7.22v1.8h-7.22z"}})])
          )
        }
      }
    